































































import {Component, Prop, Vue} from "vue-property-decorator";
import UserInfoEdit from "@/component/mypage/user-info-edit.vue";
import UserInfoChangeMailAddress from "@/component/mypage/user-info-change-mail-address.vue";
import UserInfoChangePassword from "@/component/mypage/user-info-change-password.vue";
import {UserInfoForUpdateTmpModel} from "@/model/user-info/user-info-for-update-tmp.model";
import {DisplayUtils} from "@/display-utils";
import {CommonConstant} from "@/common-constant";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";

@Component({
  components: {UserInfoEdit, UserInfoChangeMailAddress, UserInfoChangePassword}
})
export default class UserInfoView extends Vue {

  @Prop() private model!: UserInfoForUpdateTmpModel;

  /** 共通ID表示名 */
  commonIdName: string = CommonConstant.COMMON_ID_NAME;

  // ダイアログ画面の表示制御用フラグ
  showUserInfoEditFlag:boolean = false;
  showMailEditFlag:boolean = false;
  showPasswordEditFlag: boolean = false;

  isShowMailBtn() {
    if (typeof this.model.isSns === 'undefined') {
      // SNSユーザかどうか不明な場合は表示しない
      return false;
    }
    return !this.model.isSns
  }

  isPrivateMail() {
    // 共通ID情報取得エンドポイントが遅延した場合、判断不明のためfalseを返却
    if (typeof this.model.user.mail === 'undefined') {
      return false;
    }
    // プライベートメールの場合文言を変更する
    return (this.model.user.mail.lastIndexOf("@privaterelay.appleid.com") != -1);
  }

  /** BSECからの遷移の場合に表示するメッセージの判定 */
  isShownLogoutMessage() {
    // BSECから遷移、かつ、redirectUrlが指定されている場合
    return DisplayUtils.isBsecMode() && sessionStorage.getItem("redirectUrl");
  }

  /** 共通ID変更画面の表示 */
  showUserEdit() {
    // 背景がスクロースしないように画面を固定する
    document.body.classList.add('modal-opened');
    // ダイアログを表示する
    this.showUserInfoEditFlag = true;
  }

  /** 共通ID変更画面の非表示 */
  closeUserInfoEdit(model:UserInfoForUpdateTmpModel) {
    // 背景の固定を解除する
    document.body.classList.remove('modal-opened');
    // ダイアログを閉じる
    this.showUserInfoEditFlag = false;

    if (model) {
      this.$emit('closeUserInfoEdit', this.model);
    }
  }

  /** メールアドレス変更画面の表示 */
  showMailEdit() {
    // 背景がスクロースしないように画面を固定する
    document.body.classList.add('modal-opened');
    // ダイアログを表示する
    this.showMailEditFlag = true;
  }

  /** メールアドレス変更画面の非表示 */
  closeMailEdit(mail:string) {
    // 背景の固定を解除する
    document.body.classList.remove('modal-opened');
    // ダイアログを閉じる
    this.showMailEditFlag = false;

    if (mail) {
      this.model.user.mail = mail;
      this.$router.push("/client/mail-confirm-waiting");
    }
  }

  /** パスワード変更画面の表示 */
  showPasswordEdit() {
    // 背景がスクロースしないように画面を固定する
    document.body.classList.add('modal-opened');
    // ダイアログを表示する
    this.showPasswordEditFlag = true;
  }

  /** パスワード変更画面の非表示 */
  closePasswordEdit(isSend: boolean = false) {
    // 背景の固定を解除する
    document.body.classList.remove('modal-opened');
    // ダイアログを閉じる
    this.showPasswordEditFlag = false;
    if (isSend) {
      this.$emit('closePasswordEdit');
    }
  }

  /** ログアウトした後、元のサービスにリダイレクトする */
  logoutAndRedirect() {
    let params = `?redirect_uri=${encodeURIComponent(sessionStorage.getItem("redirectUrl"))}`;
    axios.get(`/logoutAndRedirect${params}`).then(cb => {
      if (cb.data) {
        sessionStorage.clear();
        window.location.href = cb.data.toString();
      } else {
        // URLが指定されていない場合、エラー画面へ遷移
        this.$router.push("/client/error");
      }
    }).catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
  }
}
